import { omrehBaseClient } from "./client";

const GetAgeTypeArabianDropDown=()=>{
   return omrehBaseClient
       .get("/StaticVariables/GetAgeTypeArabianDropDown"); 
}
const GetDegreeOfRelativityDropDown=()=>{
    return omrehBaseClient
        .get("/StaticVariables/GetDegreeOfRelativityDropDown");
}
const GetAirLineType=()=>{
    return omrehBaseClient.get('StaticVariables/GetAirLineTypeDropDown')
  }
  const GetCurrency=()=>{
    return omrehBaseClient.get('StaticVariables/GetCurrencyDropDown')
  }
  const GetMealTypeDropDown=()=>{
  return omrehBaseClient.get('StaticVariables/GetMealTypeDropDown')
}
const GetVehicleTypeDropDown=()=>{
  return omrehBaseClient.get('StaticVariables/GetVehicleTypeDropDown')
}
const GetGuestTypeDropDown=()=>{
  return omrehBaseClient.get('StaticVariables/GetGuestTypeDropDown')
}
const staticVariablesApi = {
    GetAgeTypeArabianDropDown, GetDegreeOfRelativityDropDown,GetAirLineType,GetCurrency,GetMealTypeDropDown,GetVehicleTypeDropDown,GetGuestTypeDropDown
}



export default staticVariablesApi